import {message, Modal, Table} from 'antd';
import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import {findVitals} from 'services/PatientService';
import {handleError} from 'utils/MessageUtils';
import {EQUAL} from 'shared/constants/QueryModes';
import {VITAL_QUERY_SIZE_LIMIT, VitalType} from 'shared/constants/AppConst';

export const List = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const {patientId, viewing, setViewing} = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = () => {
    setLoading(true);
    findVitals(headers, patientId, {
      pagination: {current: 1, pageSize: VITAL_QUERY_SIZE_LIMIT},
      filters: [
        {
          fields: 'type',
          mode: EQUAL,
          value: VitalType.BODY_HEIGHT,
        },
      ],
      sorters: [
        {
          field: 'modifiedDate',
          order: 'descend',
        },
      ],
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => handleError(message, error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (viewing) {
      loadData();
    }
  }, [viewing]);

  const onCancel = () => {
    setViewing(false);
  };

  const columns = [
    {
      title: intl.messages['common.modifiedDate'],
      dataIndex: 'modifiedDate',
      key: 'modifiedDate',
    },
    {
      title: intl.messages['common.value'],
      dataIndex: 'value',
      key: 'value',
    },
  ];

  return (
    <Modal
      title={intl.messages['patient.bodyHeight']}
      centered
      visible={viewing}
      onCancel={() => onCancel()}
      destroyOnClose={true}
      footer={null}>
      <Table
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        pagination={false}
        scroll={{x: 'auto'}}
      />
    </Modal>
  );
};

List.propTypes = {
  patientId: PropTypes.string,
  viewing: PropTypes.bool,
  setViewing: PropTypes.func,
};
